import type { IconProps } from "./types";

export function SideClose({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 0C18.6569 0 20 1.34315 20 3V13C20 14.6051 18.7394 15.9158 17.1543 15.9961L17 16H3L2.8457 15.9961C1.26055 15.9158 0 14.6051 0 13V3C0 1.34315 1.34315 6.44256e-08 3 0H17ZM3 1.7998C2.33726 1.7998 1.7998 2.33726 1.7998 3V13C1.7998 13.6627 2.33726 14.2002 3 14.2002H6.25V1.7998H3ZM8.0498 14.2002H17C17.6627 14.2002 18.2002 13.6627 18.2002 13V3C18.2002 2.33726 17.6627 1.7998 17 1.7998H8.0498V14.2002ZM13.3633 4.36328C13.7147 4.01183 14.2852 4.01186 14.6367 4.36328C14.9882 4.71475 14.9882 5.28525 14.6367 5.63672L12.2734 8L14.6367 10.3633C14.9882 10.7148 14.9882 11.2852 14.6367 11.6367C14.2852 11.9881 13.7147 11.9882 13.3633 11.6367L10.3633 8.63672C10.0338 8.30718 10.0134 7.78512 10.3018 7.43164L10.3633 7.36328L13.3633 4.36328Z"
        fill={currentColor}
        transform="translate(2 4)"
      />
    </svg>
  );
}
